module.exports = __webpack_public_path__ + "img/onboarding_image.740c0a65.png";